export default __webpack_public_path__ + "static/media/banco-av-villas.36278561.svg";